import React from 'react';
import {Carousel, Typography} from "@material-tailwind/react";
import {
    ClipboardDocumentListIcon,
    FireIcon, BoltIcon, DocumentDuplicateIcon, WrenchIcon, GlobeAltIcon, EnvelopeIcon
} from "@heroicons/react/24/outline";
import {LandingMenu} from "../components/common/LandingMenu";
import {PhoneIcon} from "@heroicons/react/16/solid";
import {Link} from "react-router-dom";
import {Menu} from "../components/common/Menu";

import { motion } from 'framer-motion';

function LandingPage() {

    const isAuthenticated = !!localStorage.getItem("token");

    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="overflow-hidden">
                    <div className="justify-center w-[calc(100%)] min-h-screen bg-white">
                    <div className="h-5 bg-gray-50"></div>

                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                            {/* Levi krug */}
                            <div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                                 style={{ top: '90%', left: '30%', transform: 'translate(-80%, -50%)' }}></div>
                            {/* Desni krug */}
                            <div className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                                 style={{ top: '80%', left: '60%', transform: 'translate(-20%, -50%)' }}></div>
                            {/* Donji krug */}
                            {/*<div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"*/}
                            {/*     style={{ top: '120%', left: '60%', transform: 'translate(-50%, 10%)' }}></div>*/}
                        </div>
                    <div>
                        <div className="px-2">
                            {isAuthenticated ? <Menu /> : <LandingMenu />}
                        </div>

                        <motion.div
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75 }}
                        >

                        <div className="h-6 bg-grayblue-50"></div>
                        <div className=" flex flex-col relative z-10">
                            <div className="relative h-[75vh] w-full container mx-auto px-2">
                                {/* Karusel */}
                                <Carousel
                                    className="rounded-xl h-full w-full"
                                    autoplay={true}
                                    autoplayDelay={6000}
                                    transition={{ type: "tween", duration: 0.8, ease: "easeInOut" }}
                                    loop={true}
                                    prevArrow={({ handlePrev }) => <span className="hidden" />}
                                    nextArrow={({ handleNext }) => <span className="hidden" />}
                                >
                                    <img
                                        src="/images/landing-page/naslovna.jpg"
                                        alt="naslovna 1"
                                        className="h-full w-full object-cover"
                                        style={{ filter: 'brightness(0.25)' }}
                                    />
                                    <img
                                        src="/images/landing-page/naslovna2.JPEG"
                                        alt="naslovna 2"
                                        className="h-full w-full object-cover"
                                        style={{ filter: 'brightness(0.25)' }}
                                    />
                                    <img
                                        src="/images/landing-page/naslovna3.JPEG"
                                        alt="naslovna 3"
                                        className="h-full w-full object-cover"
                                        style={{ filter: 'brightness(0.25)' }}
                                    />
                                    <img
                                        src="/images/landing-page/hummel-hilft-q-caloric.jpg"
                                        alt="naslovna 3"
                                        className="h-full w-full object-cover"
                                        style={{ filter: 'brightness(0.25)' }}
                                    />
                                </Carousel>

                                {/* Hero tekst */}
                                <div className="absolute inset-0 flex flex-col items-start justify-center px-8 sm:px-16 lg:px-24 text-white space-y-6 pointer-events-none ">
                                    <h1 className="text-3xl sm:text-5xl lg:text-5xl ml-6 lg:ml-1 font-bold leading-tight text-blue-gray-400">
                                        Smart Service<br /> System
                                    </h1>
                                    <h2 className="text-xl sm:text-3xl lg:text-3xl ml-6 lg:ml-1 font-medium text-blue-gray-700">
                                        Vaša energija,<br /> Naša briga
                                    </h2>
                                    <br />
                                    <Link to="/kontakt" className="pointer-events-auto ml-6 lg:ml-1">
                                      <span className="text-blue-gray-400 font-bold text-2xl border-b-[5px] border-blue-300 pb-1 hover:text-blue-gray-700 hover:border-blue-500">
                                        Kontaktirajte nas
                                      </span>
                                    </Link>
                                </div>
                            </div>

                            <div className="w-full border-b-10 border-[#1e88e5]">
                                <div className="flex flex-col sm:flex-row gap-4 mt-8 pb-8 container mx-auto px-2">
                                {/* Prvi div - O nama */}
                                    <div className="w-full sm:w-1/2 ml-2">
                                            <span className="block text-blue-600 text-xl sm:text-2xl font-semibold mt-4 mb-6">O nama</span> {/* Plavi tekst sa razmakom */}
                                        <h2 className="text-3xl sm:text-3xl font-normal mr-2">
                                            Saznajte više o našim<br />
                                            <span className="text-blue-500">uslugama</span> i zašto smo
                                            najbolji<br /> u svom poslu.
                                        </h2>
                                        <p className="mt-8 text-[17px] sm:text-xl font-light mb-8 mr-2">
                                            Mi smo firma koja se <span className="font-semibold">specijalizovala</span> za očitavanje merila toplotne energije i raspodelu utroška energenta, sa misijom
                                            da svojim korisnicima omogućimo preciznu kontrolu nad potrošnjom energije.<br /> Od 2016. godine, pomažemo kako domaćinstvima,
                                            tako i poslovnim korisnicima da bolje razumeju i upravljaju svojim energetskim resursima.
                                        </p>
                                        <a href="/o_nama" className="text-gray-800 font-bold text-xl border-b-[5px] border-blue-600 pb-1 hover:text-blue-600">Pročitajte više</a>

                                    </div>

                                    {/* Drugi div - Usmereni poslovi */}
                                    <div className="w-full sm:w-1/2 flex items-center justify-center mt-8 sm:ml-16 ml-2">
                                        <div className="flex flex-col items-start w-full">
                                            {/* Očitavanje merila toplotne energije */}
                                            <div className="offers mb-6 text-left flex items-center ml-6">
                                                <ClipboardDocumentListIcon className="h-16 w-16 text-blue-600 mr-6 flex-shrink-0" />
                                                <span className="text-lg lg:text-3xl font-light mr-2">Očitavanje merila toplotne energije</span>
                                            </div>

                                            {/* Raspodela potrošnje gasa */}
                                            <div className="offers mb-6 text-left flex items-center ml-6">
                                                <FireIcon className="h-16 w-16 text-blue-600 mr-6 flex-shrink-0" />
                                                <span className="text-lg lg:text-3xl font-light mr-2">Raspodela potrošnje gasa</span>
                                            </div>

                                            {/* Raspodela potrošnje električne energije */}
                                            <div className="offers mb-6 text-left flex items-center ml-6">
                                                <BoltIcon className="h-16 w-16 text-blue-600 mr-6 flex-shrink-0" />
                                                <span className="text-lg lg:text-3xl font-light mr-2">Raspodela potrošnje električne energije (toplotne pumpe)</span>
                                            </div>

                                            {/* Izrada elaborata o načinu raspodele potrošnje */}
                                            <div className="offers mb-6 text-left flex items-center ml-6">
                                                <DocumentDuplicateIcon className="h-16 w-16 text-blue-600 mr-6 flex-shrink-0" />
                                                <span className="text-lg lg:text-3xl font-light mr-2">Izrada elaborata o načinu raspodele potrošnje</span>
                                            </div>

                                            {/* Servis merila toplotne energije */}
                                            <div className="offers mb-6 text-left flex items-center ml-6">
                                                <WrenchIcon className="h-16 w-16 text-blue-600 mr-6 flex-shrink-0" />
                                                <span className="text-lg lg:text-3xl font-light mr-2">Servis merila toplotne energije</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-[#f8f8f8] py-8">
                                <div className="flex flex-col sm:flex-row gap-4 mt-8 container mx-auto px-2">
                                    {/* Prvi div - Slika sa leve strane */}
                                    <div className="w-full sm:w-1/2">
                                        <img
                                            className="h-32 sm:h-60 w-full rounded-lg object-cover object-center"
                                            src="/images/landing-page/ocitavanje.jpg"
                                            alt="Ocitavanje"
                                        />
                                    </div>

                                    {/* Drugi div - Tekst sa desne strane */}
                                    <div className="w-full sm:w-1/2 sm:ml-16 mt-4 sm:mt-0 ml-2 flex items-center justify-center">
                                        <div className="text-col-6 text-left">
                                            <h2 className="text-3xl font-semibold text-gray-800 mr-2">Očitavanje merila toplotne energije</h2>
                                            <p className="mt-6 text-[17px] font-light mr-2">
                                                Naša firma se specijalizovala za precizno očitavanje merila toplotne energije svih proizvođača, koristeći najnoviju tehnologiju kako bismo obezbedili tačne i pravovremene podatke. <br /> Ovim uslugama omogućavamo korisnicima bolju kontrolu nad potrošnjom i optimizaciju energetskih resursa.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-8 container mx-auto px-2">
                                    {/* Prvi div - Tekst sa leve strane */}
                                    <div className="w-full sm:w-1/2 sm:mr-16 mt-4 sm:mt-0 ml-2 flex items-center justify-center">
                                        <div className="text-col-6 text-left">
                                            <h2 className="text-3xl font-semibold text-gray-800 mr-2">Raspodela potrošnje gasa</h2>
                                            <p className="mt-6 text-[17px] font-light mr-2">
                                                Pružamo usluge raspodele potrošnje gasa na temelju tačnih merenja , omogućavajući korisnicima da razumeju i pravilno rasporede energetske troškove. <br />
                                                Naša metoda temelji se na pažljivoj analizi podataka, što korisnicima omogućava jasnu podelu troškova i bolju kontrolu nad potrošnjom.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Drugi div - Slika sa desne strane */}
                                    <div className="w-full sm:w-1/2">
                                        <img
                                            className="h-32 sm:h-60 w-full rounded-lg object-cover object-center"
                                            src="/images/landing-page/raspodela-ench.jpg"
                                            alt="Raspodela potrosnje"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-8 container mx-auto px-2">
                                    {/* Prvi div - Slika sa leve strane */}
                                    <div className="w-full sm:w-1/2">
                                        <img
                                            className="h-32 sm:h-60 w-full rounded-lg object-cover object-center"
                                            src="/images/landing-page/toplotne-pumpe.jpg"
                                            alt="toplotne pumpe"
                                        />
                                    </div>

                                    {/* Drugi div - Tekst sa desne strane */}
                                    <div className="w-full sm:w-1/2 sm:ml-16 mt-4 sm:mt-0 ml-2 flex items-center justify-center">
                                        <div className="text-col-6 text-left">
                                            <h2 className="text-3xl font-semibold text-gray-800 mr-2">Raspodela potrošnje električne energije (toplotne pumpe)</h2>
                                            <p className="mt-6 text-[17px] font-light mr-2">
                                                Nudimo usluge raspodele potrošnje električne energije, naročito za sisteme toplotnih pumpi, kako bi korisnici mogli da optimizuju energetske troškove. <br />
                                                Naš pristup omogućava preciznu distribuciju potrošnje i povećanje energetske efikasnosti.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-8 container mx-auto px-2">
                                    {/* Prvi div - Tekst sa leve strane */}
                                    <div className="w-full sm:w-1/2 sm:mr-16 mt-4 sm:mt-0 ml-2 flex items-center justify-center">
                                        <div className="text-col-6 text-left">
                                            <h2 className="text-3xl font-semibold text-gray-800 mr-2">Izrada elaborata o načinu raspodele potrošnje </h2>
                                            <p className="mt-6 text-[17px] font-light mr-2">
                                                Nudimo izradu elaborata koji su neophodni za povezivanje na gasnu mrežu u slučaju da korisnici poseduju merila toplotne energije. <br />
                                                Ovi elaborati detaljno razrađuju način raspodele potrošnje i omogućavaju usklađivanje sa propisima i tehničkim zahtevima.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Drugi div - Slika sa desne strane */}
                                    <div className="w-full sm:w-1/2">
                                        <img
                                            className="h-32 sm:h-60 w-full rounded-lg object-cover object-center"
                                            src="/images/landing-page/depositphotos-220100076-stock-photo-stacks-documents-files-black-clip.jpg"
                                            alt="Izrada elaborata"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-8 mb-8 container mx-auto px-2">
                                    {/* Prvi div - Slika sa leve strane */}
                                    <div className="w-full sm:w-1/2">
                                        <img
                                            className="h-32 sm:h-60 w-full rounded-lg object-cover object-center"
                                            src="/images/landing-page/servis.jpg"
                                            alt="Servis merila toplotne energije"
                                        />
                                    </div>

                                    {/* Drugi div - Tekst sa desne strane */}
                                    <div className="w-full sm:w-1/2 sm:ml-16 mt-4 sm:mt-0 ml-2 flex items-center justify-center">
                                        <div className="text-col-6 text-left">
                                            <h2 className="text-3xl font-semibold text-gray-800 mr-2">Servis merila toplotne energije</h2>
                                            <p className="mt-6 text-[17px] font-light mr-2">
                                                Našim korisnicima nudimo servis merila toplotne energije, koji uključuje preciznu dijagnostiku uređaja u slučaju kvara.  <br />
                                                Naš tim stručnjaka brzo identifikuje problem i obezbeđuje pouzdanu zamenu, uz garanciju na novi uređaj.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-full border-t-10 border-[#1e88e5]">
                                <div className="flex flex-col sm:flex-row gap-4 pt-8 container mx-auto px-2">
                                    {/* Levi div - Tekst */}
                                    <div className="w-full sm:w-1/3 flex items-center justify-center mt-4 sm:mt-0 ml-2">
                                        <div className="text-col-6 text-left">
                                            <h2 className="text-3xl font-semibold text-gray-800">Naši partneri</h2>
                                            <p className="mt-2 text-[17px] font-light mr-2">
                                                Ponosni smo na saradnju sa ključnim kompanijama i organizacijama koje se odlikuju visokim standardima kvaliteta, stručnosti i inovacija. Naši partneri su temelji našeg poslovanja, jer zajedno radimo na stvaranju rešenja koja zadovoljavaju potrebe tržišta i omogućavaju stalni napredak.
                                            </p>
                                            <p className="mt-4 text-[17px] font-light mr-2">
                                                Ukoliko želite da saznate više o mogućnostima saradnje, <a href="/kontakt" className="text-gray-800 font-bold text-xl border-b-[5px] border-blue-600 pb-1 hover:text-blue-600">kontaktirajte nas.</a>
                                            </p>
                                        </div>
                                    </div>

                                    {/* Desni div - Slike */}
                                    <div className="w-full sm:w-2/3 grid grid-cols-3 gap-4 sm:ml-16">
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/gas.jpg" alt="Gas" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/informatika.jpg" alt="Informatika" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/Logo-der-QUNDIS-Gmb-H.jpg" alt="Qundis partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/energy-net-logo-1.jpg" alt="EnergyNet partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/logo-residence-2.jpg" alt="Fruske residence partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/ezgif-4-bde0043946.jpg" alt="Modena Gradnja partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/infiniti.jpg" alt="Infiniti021 partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/maior-domus.jpg" alt="Maior Domus partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/hm-logo-gh.jpg" alt="House Man partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/Erker-1.jpg" alt="Erker partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/www-gradnja.jpg" alt="Tim inzenjering partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/dream-home.jpg" alt="Dream Home partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/buha2.jpg" alt="Buha" />
                                        <img className="h-24 w-48 object-contain" src="/images/landing-page/rapid2.jpg" alt="Rapid Invest partner" />
                                        <img className="h-24 w-48 rounded-lg object-contain" src="/images/landing-page/149052597-330839015029977-3665330885064385787-n.jpg" alt="ProCasa partner" />
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-4 mt-24 mb-4">
                                <footer className="relative w-full">
                                    <div className="mx-auto w-full max-w-7xl px-8">
                                        <div className="mx-auto grid w-full grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">

                                            <div className="w-full flex items-center justify-start lg:justify-center">
                                                <img
                                                    src="/transparent logo.png"
                                                    alt="Smart Service System Logo"
                                                    className="h-24 w-auto"
                                                />
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Navigacija
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Link to="/">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Početna strana</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/o_nama">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">O nama</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/saveti">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Saveti</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/kontakt">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Kontakt</span>
                                                        </Typography>
                                                    </Link>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Kontakt
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Za sva Vaša pitanja</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">stojimo na raspolaganju</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">svakog radnog dana</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">od 12-14h</span>
                                                    </Typography>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <div className="flex items-center space-x-4 mb-4">
                                                    <GlobeAltIcon className="h-5 w-5 text-gray-900" />
                                                    <EnvelopeIcon className="h-5 w-5 text-gray-900" />
                                                    <PhoneIcon className="h-5 w-5 text-gray-900" />
                                                </div>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">www.smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">info@smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">+381 61 528 00 18</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <a  href="/Politika%20privatnosti.pdf" target="_blank" rel="noopener noreferrer" className="inline-block py-1 pr-2">Politika privatnosti</a>
                                                    </Typography>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="flex w-full flex-col items-center justify-center border-t border-blue-gray-50 py-4 md:flex-row md:justify-between">
                                            <Typography
                                                variant="small"
                                                className="mb-4 text-center font-normal text-blue-gray-900 md:mb-0"
                                            >
                                                &copy; {currentYear} <a href="https://smartservicesystem.rs/">Smart Service System</a>. Sva
                                                prava zadržana.
                                            </Typography>
                                        </div>
                                    </div>
                                </footer>
                            </div>

                        </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LandingPage;